var TAG = "auph";
var lastStatus = 0;
export function log(message) {
    if (process.env.NODE_ENV !== "production") {
        console.log(TAG, message);
    }
}
export function warn(message) {
    if (process.env.NODE_ENV !== "production") {
        console.warn(TAG, message);
    }
}
export function error(message, reason) {
    if (process.env.NODE_ENV !== "production") {
        console.error(TAG, message, reason);
    }
}
export function setError(status, context) {
    if (process.env.NODE_ENV !== "production") {
        error(status, context);
    }
    lastStatus = status;
}
//# sourceMappingURL=debug.js.map